import { createSelector } from 'reselect';

import getHistory from './getHistory';

const hasSeenRouteSelector = (state, route) => {
    const { routes } = getHistory(state);
    return routes.includes(route);
};

export default createSelector(hasSeenRouteSelector, (hasSeenRoute) => hasSeenRoute);
